(function () {
  function getQtyInput(form) {
    return form ? form.querySelector('.tmb-card-qty-input') : null;
  }

  function getVariantId(form) {
    const input = form ? form.querySelector('input[name="id"]') : null;
    return input ? input.value : null;
  }

  function getQty(form) {
    const input = getQtyInput(form);
    const qty = parseInt(input && input.value ? input.value : '1', 10);
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function setBusy(button, busy) {
    if (!button) return;
    button.disabled = busy;
    button.style.opacity = busy ? '0.7' : '';
  }

  async function addToCart(variantId, quantity) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity
          }
        ]
      })
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || 'Add to cart failed');
    }

    return response.json();
  }

  async function waitForCartQuantity(variantId, quantity) {
    for (let i = 0; i < 8; i++) {
      const response = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      });

      if (response.ok) {
        const cart = await response.json();
        const matchingLines = (cart.items || []).filter(function (item) {
          return String(item.id) === String(variantId);
        });

        const totalQty = matchingLines.reduce(function (sum, item) {
          return sum + (item.quantity || 0);
        }, 0);

        if (totalQty >= quantity) {
          return true;
        }
      }

      await new Promise(function (resolve) {
        setTimeout(resolve, 150);
      });
    }

    return false;
  }

  document.addEventListener('click', async function (e) {
    const stepBtn = e.target.closest('.tmb-card-step');
    if (stepBtn) {
      e.preventDefault();
      e.stopPropagation();

      const form = stepBtn.closest('.tmb-card-form');
      const qtyInput = getQtyInput(form);
      if (!qtyInput) return;

      const current = getQty(form);

      if (stepBtn.dataset.step === 'up') {
        qtyInput.value = current + 1;
      } else {
        qtyInput.value = Math.max(1, current - 1);
      }
      return;
    }

    const buyNowBtn = e.target.closest('.tmb-buy-now-btn');
    if (buyNowBtn) {
      e.preventDefault();
      e.stopPropagation();

      const form = buyNowBtn.closest('.tmb-card-form');
      const variantId = getVariantId(form);
      const quantity = getQty(form);

      if (!variantId) return;

      try {
        setBusy(buyNowBtn, true);
        await addToCart(variantId, quantity);
        await waitForCartQuantity(variantId, quantity);
        window.location.href = '/checkout';
      } catch (err) {
        console.error('Buy Now failed:', err);
        setBusy(buyNowBtn, false);
      }
      return;
    }
  }, true);

  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('.tmb-card-form');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();

    const submitBtn = form.querySelector('.tmb-card-atc button');
    const variantId = getVariantId(form);
    const quantity = getQty(form);

    if (!variantId) return;

    try {
      setBusy(submitBtn, true);
      await addToCart(variantId, quantity);

      if (window.theme && theme.drawer && typeof theme.drawer.open === 'function') {
        theme.drawer.open('right', 'cart-drawer', form);
      }
    } catch (err) {
      console.error('Add to Cart failed:', err);
    } finally {
      setBusy(submitBtn, false);
    }
  }, true);
})();